import React from "react";
import { Route, IndexRoute } from "react-router";
import App2 from "./components/app";

import HomeIndex from "./components/index_home";
import UserLogin from "./components/Screens/Login/login";
import LandingPage from "./components/Screens/landingPage/LandingPage";
import Grocer from "./components/Screens/landingPage/Grocer";
import Workers from "./components/Screens/landingPage/Workers";
import WorkerSecure from "./components/Screens/landingPage/WorkerSecure";
import index_home from "./components/index_home";
import SupplierAdmin from "./components/Screens/landingPage/SupplierAdmin";

export default (
  <Route path="/" component={App2}>
    <IndexRoute component={index_home} />
    <Route path="/landingPage" component={LandingPage} />
    <Route path="/rajdhani" component={Grocer} />
    <Route path="/zara" component={Grocer} />
    <Route path="/tanmoy" component={Grocer} />
    <Route path="/supplier4" component={Grocer} />
    <Route path="/supplier5" component={Grocer} />
    <Route path="/workers" component={Workers} />
    <Route path="/workersecure" component={WorkerSecure} />
    <Route path="/login" component={UserLogin} />
    <Route path="/supplieradmin" component={SupplierAdmin} />
  </Route>
);



// WEBPACK FOOTER //
// ./src/app/routes.jsx